import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useGoogleMaps } from '@bluheadless/ui-logic/src/hooks/google/useGoogleMaps'
import { useStoreLocatorStores } from '@bluheadless/ui-logic/src/hooks/store-locator/useStoreLocatorStores'
import { useTheme } from '@mui/system'
import { cx } from '@emotion/css'
import { number, string } from 'prop-types'
import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Typography from '../../atoms/typography'
import SkeletonCard from '../../molecules/skeleton/card/skeleton-card'
import StoreLocatorCard from '../../molecules/store-locator/card/store-locator-card'
import { Slide } from '../../particles/slider'
import { getDistance } from '../../utils/store-locator'
import Carousel from '../carousel'
import { Root } from './nearby-stores.styled'

const NearbyStores = ({ latitude, longitude, currentStore, title, className }) => {
	const { stores: _stores, loading } = useStoreLocatorStores({
		where: currentStore && {
			_id: {
				neq: currentStore,
			},
		},
	})
	const {
		storelocator: {
			nearbyStores: { limit },
		},
	} = useConfig()

	const theme = useTheme()
	const status = useGoogleMaps()
	const [allStores, setAllStores] = useState([])

	useEffect(() => {
		if (_stores?.length && status === 'ready') {
			let stores = [..._stores]

			stores?.map((store) => {
				store.distanceInMt = getDistance(
					{ lat: latitude, lng: longitude },
					{ lat: store.latitude, lng: store.longitude }
				)
			})

			stores?.sort((a, b) => a?.distanceInMt - b?.distanceInMt)

			setAllStores(stores.slice(0, limit))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [_stores, status])

	return (
		<Root className={cx('NearbyStores-root', className)}>
			{loading ? (
				<SkeletonCard
					responsiveProps={{
						lg: {
							cardRatio: 0.8,
							columnGap: 10,
							columns: 3,
							rowGap: 1,
						},
						md: {
							cardRatio: 0.8,
							columns: 3,
						},
						sm: {
							cardRatio: 0.8,
							columns: 2,
						},
						xs: {
							cardRatio: 0.8,
							columns: 1,
						},
					}}
					rows={1}
				/>
			) : _stores?.length > 0 ? (
				<Carousel
					slidesPerView={1.5}
					spaceBetween={20}
					controlsPosition="top-right"
					titleComponent={
						<Typography variant="h2" mb={5}>
							{title || <FormattedMessage id="store_locator_nearby_stores" />}
						</Typography>
					}
					breakpoints={{
						[theme.breakpoints.values.xs]: {
							slidesPerView: 1,
						},
						[theme.breakpoints.values.sm]: {
							slidesPerView: 2,
						},
						[theme.breakpoints.values.md]: {
							slidesPerView: 3,
						},
						[theme.breakpoints.values.lg]: {
							slidesPerView: 3,
						},
					}}
				>
					{allStores.map((store, index) => (
						<Slide key={index}>
							<StoreLocatorCard store={store} />
						</Slide>
					))}
				</Carousel>
			) : null}
		</Root>
	)
}

NearbyStores.defaultProps = {}

NearbyStores.propTypes = {
	currentStore: string,
	latitude: number,
	longitude: number,
	className: string,
	title: string,
}

export default NearbyStores
